import React, { Component, useRef } from "react";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import Loader from "../../../../component/loader";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tabs,
  Tab,
  IconButton,
  FormHelperText,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ButtonGroup,
  FormControl,
  InputLabel,
  Select,
  Divider,
  MenuItem,
  Box,
  Checkbox,
} from "@mui/material";
import Input from "../../../../component/inputpm";
import Pagination from "@mui/material/Pagination";
import Button from "../../../../component/button";
import Tooltip from "@mui/material/Tooltip";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
} from "../../../../component/icons/icons";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import { formatNumber } from "../../../../helper/numberFormatter";
// import { withStyles } from '@mui/styles';

class ProductSpecificationsListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      searchSpecName: "",
      searchSpecDescription: "",
      searchSpecCategory: "PSC_PROD",
      searchProductSpecCode: "",
      allProductSpecifications: [],
      rowsPerPageAllSpec: 20,
      pageAllSpec: 1,
      startRecordAllSpec: 1,
      totalAllSpecificationCount: 0,
      dialogOpenSpecification: false,
      formDataSpecification: {
        id: "",
        description: "",
        name: "",
        parentId: "",
        visibility: "",
        category: { id: "", name: "" },
        productCategory: { id: "", name: "" },
        isMandatory: false,
        productSpecCode: "",
      },
      parentSpecId: "",
      callFrom: "",
      specificationFormErrors: {
        name: false,
        description: false,
        productSpecCode: false,
      },
      specCategoryList: [],
      specProductCategoryList: [],
    };
  }

  componentDidMount() {
    //this.setState({ allProductSpecifications: this.props.allProductSpecifications,  totalAllSpecificationCount: this.props.allSpecificationCount});
    this.getAllSpecificationListData();
    this.getCategoryList();
    this.getProductCategoryList();
  }
  /*componentDidUpdate(prevProps) {
        if (prevProps.allProductSpecifications !== this.props.allProductSpecifications) {
            this.setState({ allProductSpecifications: this.props.allProductSpecifications,  totalAllSpecificationCount: this.props.allSpecificationCount});
        }
    }*/

  onChangeSpecSearchCate = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (fieldName == "searchSpecCategory") {
          this.getAllSpecificationListData();
        }
      },
    );
  };

  onChangeSpecSearchProdCate = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (fieldName == "searchSpecProductCategory") {
          this.getAllSpecificationListData();
        }
      },
    );
  };

  getCategoryList = () => {
    const formData = { type: "PRODUCT_SPEC_CAT" };
    const prioritizedItemId = "PSC_PROD";
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PROD_SPEC_CHAR_CAT/endpoint`,
      formData,
    )
      .then((res) => {
        if (res.data?.categories) {
          const sortedCategoryList = [
            ...res.data.categories.filter(
              (item) => item.id === prioritizedItemId,
            ),
            ...res.data.categories
              .filter((item) => item.id !== prioritizedItemId)
              .sort((a, b) => a.name.localeCompare(b.name)),
          ];
          this.setState({ specCategoryList: sortedCategoryList });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Spec Category:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    //this.setState({showLoading: false});
  };

  getProductCategoryList = () => {
    BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`)
      .then((res) => {
        let data = res.data;
        let cData = JSON.parse(data.jsonResponse);
        const sortedCategoryList = [
          ...cData.mappedTypes
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(({ id, name }) => ({ id, name })),
        ];
        this.setState({ specProductCategoryList: sortedCategoryList });
      })
      .catch((err) => {
        console.error("Error fetching Product Categories:", err);
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  getAllSpecificationListData = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageAllSpec,
      startRecord: this.state.startRecordAllSpec,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC&showAllSpecs=true${this.state.searchSpecName ? "&name=" + this.state.searchSpecName : ""}${this.state.searchSpecDescription ? "&description=" + this.state.searchSpecDescription : ""}${this.state.searchSpecCategory && this.state.searchSpecCategory !== "-" ? "&category=" + this.state.searchSpecCategory : ""}${this.state.searchSpecProductCategory && this.state.searchSpecProductCategory !== "-" ? "&productCategory=" + this.state.searchSpecProductCategory : ""}${this.state.searchProductSpecCode ? "&productSpecCode=" + this.state.searchProductSpecCode : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          this.setState({
            allProductSpecifications: res.data,
            totalAllSpecificationCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            allProductSpecifications: [],
            totalAllSpecificationCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  selectSpecificationDialog = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent dialogHeight"
        handle="#select-specification-dialog"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} style={{ height: "500px" }} />
      </Draggable>
    );
  };

  SearchSectionAllSpecifications = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ paddingBottom: "0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            value={this.state.searchSpecName}
            name={"searchSpecName"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllSpecSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            value={this.state.searchSpecDescription}
            name={"searchSpecDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllSpecSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("PRODUCT_SPEC_CODE")}
            value={this.state.searchProductSpecCode || ""}
            name="searchProductSpecCode"
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onAllSpecSearchKeyDown}
          />
        </div>
        <div>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel id="categoryLabel">{t("CATEGORY")}</InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="searchSpecCategory"
              value={this.state.searchSpecCategory}
              native
              label="Category"
              labelId="categoryLabel"
              onKeyDown={this.onAllSpecSearchKeyDown}
              onChange={this.onChangeSpecSearchCate}
            >
              <option value="-">Select</option>
              {this.state.specCategoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div>
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel id="categoryProductLabel">
              {t("PRODUCT_CATEGORY")}
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="searchSpecProductCategory"
              value={this.state.searchSpecProductCategory}
              native
              label="Product Category"
              labelId="categoryProductLabel"
              onKeyDown={this.onAllSpecSearchKeyDown}
              onChange={this.onChangeSpecSearchProdCate}
            >
              <option value="-">Select</option>
              {this.state.specProductCategoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getAllSpecificationListData}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchAllSpec}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  PaginationAllSpecifications = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalAllSpecificationCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageAllSpec}
            onChange={this.handleChangeRowsPerPageAllSpec}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalAllSpecificationCount /
              this.state.rowsPerPageAllSpec,
          )}
          onChange={this.handleChangePageAllSpec}
          page={this.state.pageAllSpec}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  TableSectionAllSpecifications = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "15%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "15%" }}>
                <b>{t("PRODUCT_SPEC_CODE")}</b>
              </TableCell>
              <TableCell style={{ width: "20%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("VISIBILITY")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("MANDATORY")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("CATEGORY")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>{t("PRODUCT_CATEGORY")}</b>
              </TableCell>
              <TableCell style={{ width: "10%" }}>
                <b>&nbsp;&nbsp;{t("EDIT")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.allProductSpecifications.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row?.name}</TableCell>
                <TableCell>{row?.productSpecCode}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row?.description}
                </TableCell>
                <TableCell>{row?.visibility}</TableCell>
                <TableCell>{String(row?.isMandatory)}</TableCell>
                <TableCell>
                  {(() => {
                    const matchedCategory = this.state.specCategoryList.find(
                      (cat) => cat.id === row.category?.id,
                    );
                    return matchedCategory
                      ? matchedCategory.name
                      : row.category?.name;
                  })()}
                </TableCell>
                <TableCell>
                  {(() => {
                    const matchedProductCategory =
                      this.state.specProductCategoryList.find(
                        (cat) => cat.id === row.productCategory?.id,
                      );
                    return matchedProductCategory
                      ? matchedProductCategory.name
                      : row.productCategory?.name;
                  })()}
                </TableCell>
                <TableCell>
                  <Tooltip title={t("Edit")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={() => this.handleOpenDialogSpecification(row)}
                      style={{ marginBottom: ".5rem", marginLeft: ".5rem" }}
                    >
                      <EditIconNew />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {!this.state.showLoading &&
              this.state.allProductSpecifications.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_SPECIFICATION_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  handleChangeRowsPerPageAllSpec = (event) => {
    this.setState(
      {
        pageAllSpec: 1,
        rowsPerPageAllSpec: event.target.value,
        startRecordAllSpec: 1,
      },
      () => {
        this.getAllSpecificationListData();
      },
    );
  };

  handleChangePageAllSpec = (event, newPage) => {
    //console.log("this.state.rowsPerPageAllSpec",this.state.rowsPerPageAllSpec)
    //console.log("newPage",newPage)
    this.setState(
      {
        pageAllSpec: newPage,
        startRecordAllSpec: this.state.rowsPerPageAllSpec * (newPage - 1) + 1,
      },
      () => {
        this.getAllSpecificationListData();
      },
    );
  };

  clearSearchAllSpec = () => {
    this.setState(
      {
        searchSpecName: "",
        searchSpecDescription: "",
        searchSpecCategory: "-",
        searchProductSpecCode: "",
        searchSpecProductCategory: "-",
        pageAllSpec: 1,
        startRecordAllSpec: 1,
      },
      () => {
        this.getAllSpecificationListData();
      },
    );
  };

  onAllSpecSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getAllSpecificationListData();
    }
  };

  handleOpenDialogSpecification = (row) => {
    this.setState({
      dialogOpenSpecification: true,
      formDataSpecification: {
        id: row.id,
        description: row.description,
        name: row.name,
        visibility: row.visibility,
        isMandatory: row.isMandatory,
        category: row.category,
        productSpecCode: row.productSpecCode,
      },
    });
  };

  handleCloseDialogSpecification = () => {
    this.setState({
      dialogOpenSpecification: false,
      specificationFormErrors: {},
    });
  };

  handleChangeSpecification = (event) => {
    const { name, value } = event.target;
    if (name === "parentId") {
      const selectedValue = value ? value.id : ""; // Access the selected option's ID
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          [name]: selectedValue, // Update the specific field in the object
        },
      }));
    } else if (name === "category") {
      const selectedCategory = this.state.specCategoryList.find(
        (item) => item.id === value,
      );
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          category: selectedCategory || { id: "", name: "" },
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          category: !selectedCategory || !selectedCategory.id, // Error if no selection
        },
      }));
    } else {
      let error = false;
      if (name === "name") {
        error = value.trim() === ""; // Ensure name is not empty
      } else if (name === "description") {
        error = value.trim() === ""; // Ensure description is not empty
      }
      this.setState((prevState) => ({
        formDataSpecification: {
          ...prevState.formDataSpecification,
          [name]: value, // Update the specific field in the object
        },
        specificationFormErrors: {
          ...prevState.specificationFormErrors,
          [name]: error,
        },
      }));
    }
  };

  handleSubmitSpecification = () => {
    const { formDataSpecification } = this.state;
    //console.log("-----------------formDataSpecification--------------",formDataSpecification);
    const errors = {
      name: (formDataSpecification.name ?? "").trim() === "",
      description: (formDataSpecification.description ?? "").trim() === "",
      productSpecCode:
        (formDataSpecification.productSpecCode ?? "").trim() === "",
    };

    if (!Object.values(errors).some((error) => error)) {
      this.setState({ showLoading: true });
      if (formDataSpecification.id) {
        let existingSpecificationId = formDataSpecification.id;
        BusApiCall(
          "PATCH",
          `${constants.busV44UrlPublic}/productSpecifications/` +
            existingSpecificationId,
          formDataSpecification,
        )
          .then((res) => {
            this.getAllSpecificationListData();
            this.handleCloseDialogSpecification();
            this.props.setErrorMessage(
              this.props.t("SPECIFICATION_UPDATED_SUCCESSFULLY"),
              true,
            );
          })
          .catch((err) => {
            this.setState({ showLoading: false });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      } else {
        BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/productSpecifications`,
          formDataSpecification,
        )
          .then((res) => {
            this.getAllSpecificationListData();
            this.handleCloseDialogSpecification();
            this.props.setErrorMessage(
              this.props.t("SPECIFICATION_CREATED_SUCCESSFULLY"),
              true,
            );
          })
          .catch((err) => {
            this.setState({ showLoading: false });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      }
    } else {
      this.setState({ specificationFormErrors: errors });
      console.error(
        "Validation errors detected, not proceeding with API call.",
      );
    }
  };

  decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };

  render() {
    const { t, allProductSpecifications, allSpecificationCount } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <>
        <Grid container spacing={0}>
          <Loader loading={this.state.showLoading} />
          {!this.state.showLoading && (
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              <div style={{ marginBottom: ".5rem" }}>
                {this.SearchSectionAllSpecifications()}
              </div>
              <Card
                variant="outlined"
                style={{ borderRadius: "8px", marginBottom: "40px" }}
              >
                {this.TableSectionAllSpecifications()}
                {this.state.totalAllSpecificationCount >
                  this.state.rowsPerPageAllSpec &&
                  this.PaginationAllSpecifications()}
              </Card>
            </Grid>
          )}
        </Grid>
        <Dialog
          open={this.state.dialogOpenSpecification}
          maxWidth="md"
          fullWidth
          disableScrollLock={true}
          PaperComponent={this.selectSpecificationDialog}
          aria-labelledby="select-specification-dialog"
          PaperProps={
            {
              // className: jssClasses.resizablePaper
            }
          }
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              this.handleCloseDialogSpecification();
            }
          }}
        >
          {!this.state.formDataSpecification.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-specification-dialog"
            >
              {!this.state.parentSpecId
                ? t("CREATE") + " " + t("PRODUCT_SPECIFICATION")
                : t("CREATE") + " " + t("CHILD_PRODUCT_SPECIFICATION")}
            </DialogTitle>
          )}
          {this.state.formDataSpecification.id && (
            <DialogTitle
              style={{ borderBottom: "1px solid #0000001f", cursor: "move" }}
              id="select-specification-dialog"
            >
              {t("UPDATE")} {t("PRODUCT_SPECIFICATION")}
            </DialogTitle>
          )}
          <DialogContent dividers style={{ padding: "30px" }}>
            <Grid container spacing={2}>
              {/*this.state.formDataSpecification.id && (
                                    <Grid item xs={12} md={6}>
                                        <Input
                                            name="id"
                                            placeholder={`${t('PRODUCT_SPECIFICATION')} ${t('ID')}`}
                                            variant={'outlined'}
                                            divClass={classes.customDiv}
                                            size={'small'}
                                            value={this.state.formDataSpecification.id}
                                            onChange={this.handleChangeSpecification}
                                            disabled={true}
                                        />
                                    </Grid>
                                ) */}
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("NAME") + " *"}
                  name="name"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.name || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.name}
                />
                {this.state.specificationFormErrors.name && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {t("NAME_IS_REQUIRED")}
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("PRODUCT_SPEC_CODE") + " *"}
                  name="productSpecCode"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.productSpecCode || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.productSpecCode}
                  inputProps={{ maxLength: 20 }}
                  multiline={"false"}
                />
                {this.state.specificationFormErrors.productSpecCode && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {t("CODE_IS_REQUIRED")}
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={t("DESCRIPTION") + " *"}
                  name="description"
                  divClass={classes.inputClass}
                  value={this.state.formDataSpecification.description || ""}
                  onChange={this.handleChangeSpecification}
                  error={this.state.specificationFormErrors.description}
                  inputProps={{ maxLength: 255 }}
                  multiline
                />
                {this.state.specificationFormErrors.description && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {t("DESCRIPTION_IS_REQUIRED")}
                  </p>
                )}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="visibilityLabel"
                    style={{ background: "#fff" }}
                  >
                    {t("VISIBILITY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="visibility"
                    value={this.state.formDataSpecification.visibility ?? ""}
                    native
                    label={t("VISIBILITY")}
                    labelId="visibilityLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="-">{t("SELECT")}</option>
                    <option value="Commercial">{t("COMMERCIAL")}</option>
                    <option value="Technical">{t("TECHNICAL")}</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel
                    id="mandatoryLabel"
                    style={{ background: "#fff" }}
                  >
                    {t("MANDATORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="isMandatory"
                    value={
                      this.state.formDataSpecification.isMandatory ?? false
                    }
                    native
                    label={t("MANDATORY")}
                    labelId="mandatoryLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="true">{t("TRUE")}</option>
                    <option value="false">{t("FALSE")}</option>
                  </Select>
                </FormControl>
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.customeSelectLabel}
                >
                  <InputLabel id="categoryLabel" style={{ background: "#fff" }}>
                    {t("CATEGORY")}
                  </InputLabel>
                  <Select
                    size="small"
                    variant="outlined"
                    name="category"
                    value={this.state.formDataSpecification.category?.id ?? ""}
                    native
                    label={t("CATEGORY")}
                    labelId="categoryLabel"
                    onChange={this.handleChangeSpecification}
                  >
                    <option value="-">{t("SELECT")}</option>
                    {this.state.specCategoryList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {this.decodeHtml(item.name)}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleCloseDialogSpecification}
              className="button buttonSecondary"
            >
              {t("CANCEL")}
            </Button>
            {!this.state.formDataSpecification.id && (
              <Button
                variant="contained"
                className="button"
                onClick={this.handleSubmitSpecification}
              >
                {t("CREATE")}
              </Button>
            )}
            {this.state.formDataSpecification.id && (
              <Button
                variant="contained"
                className="button"
                onClick={this.handleSubmitSpecification}
              >
                {t("UPDATE")}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '65vw',
//     },
// };

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ProductSpecificationsListView));
